import { useContext } from 'react';
import { ServiceClientContext } from 'src/contexts/serviceClient/serviceClientContext';

export const useServiceClient = () => useContext(ServiceClientContext);
